import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "folder"]

  connect() {
    // Listen for Bootstrap collapse events
    const collapseElement = document.querySelector(this.element.getAttribute('href'))

    if (collapseElement) {
      collapseElement.addEventListener('show.bs.collapse', () => {
        this.updateIcon(true)
      })

      collapseElement.addEventListener('hide.bs.collapse', () => {
        this.updateIcon(false)
      })
    }
  }

  updateIcon(expanded) {
    // Update chevron/caret icon
    if (this.hasIconTarget) {
      const icon = this.iconTarget

      // Check if this is an attachment type chevron (uses rotated class)
      if (icon.classList.contains('attachment-type-chevron')) {
        if (expanded) {
          icon.classList.add('rotated')
        } else {
          icon.classList.remove('rotated')
        }
      } else {
        // Legacy behavior for other collapse icons (caret icons)
        if (expanded) {
          icon.classList.remove('fa-caret-right')
          icon.classList.add('fa-caret-down')
        } else {
          icon.classList.remove('fa-caret-down')
          icon.classList.add('fa-caret-right')
        }
      }
    }

    // Update folder icon
    if (this.hasFolderTarget) {
      const folder = this.folderTarget
      if (expanded) {
        folder.classList.remove('fa-folder')
        folder.classList.add('fa-folder-open')
      } else {
        folder.classList.remove('fa-folder-open')
        folder.classList.add('fa-folder')
      }
    }

    // Update aria-expanded
    this.element.setAttribute('aria-expanded', expanded ? 'true' : 'false')
  }
}
